<template lang="pug">
  .box
    VueApexCharts(
      ref="chart"
      type="area"
      height="350"
      :options="chartOptions"
      :series="series"
    )
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'

  export default {
    name: 'TotalLicencesChart',

    components: {
      VueApexCharts
    },

    props: ['data'],

    data () {
      return {
        show: true,
      }
    },

    watch: {
      // data () {
      //   this.show = false
      //   this.$nextTick(() => {
      //     this.show = true
      //   })
      // }
    },

    computed: {
      series () {
        return [
          {
            name: 'E-Ticaret',
            data: this.data.map(d => d.e_commerce.total)
          },
          {
            name: 'Eklenti',
            data: this.data.map(d => d.plugin.total)
          },
          {
            name: 'Pazaryeri',
            data: this.data.map(d => d.marketplace.total)
          },
          {
            name: 'POS',
            data: this.data.map(d => d.pos.total)
          },
        ]
      },

      chartOptions() {
        return {
          chart: {
            height: 350,
            type: 'area',
            stacked: true
          },
          title: {
            text: "Toplam Lisans",
            align: 'left',
            margin: 10,
          },
          labels: this.data.map(d => d.stat_date),
          colors: ["#176BA0", "#19AADE", "#1DE4BD", "#6CECC1"],
          stroke: {
            curve: 'smooth',
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '12px',
              colors: ["#176BA0"]
            },
            formatter: function (value, { seriesIndex, dataPointIndex, w }) {
              let indices = w.config.series.map((item, i) => i);
              if (seriesIndex === Math.max(...indices))
                return w.globals.stackedSeriesTotals[dataPointIndex];
              return '';
            }
          },
          tooltip: {
            shared: true,
          },
          xaxis: {
            tickPlacement: 'between',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: false,
            }
          }
        }
      }
    },

    methods: {}

  }
</script>

<style lang="scss" scoped>
</style>
